/**
 * @file index.js
 * @author Daniel Aguirre
 * @description Initialize DashboardDetail  View.
 */

// Commons
import {
  mapStateToProps,
  mapDispatchToProps
} from '@nephro/commons/mapReduxCRUD/index';

// Dependencies
import { connect } from 'react-redux';

// View
import View from './dashboardDetail';

export const mapStateToPropsDashboardDetail = mapStateToProps;
export const mapDispatchToPropsDashboardDetail = mapDispatchToProps;

export default connect(
  mapStateToPropsDashboardDetail,
  mapDispatchToPropsDashboardDetail
)(View);
